var styles = {"popup":"styles_popup__1sn0I"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
